/* Lazzoni - GCLID capture v2
   Jotform popup'i tiklamayla yuklendigi icin iframe.src'yi izliyoruz.
   theme.liquid icinde </head> oncesine eklenir. */
   (function () {
    var COOKIE = 'lz_gclid';
    var DAYS = 90;
    var IDS = ['gclid', 'gbraid', 'wbraid'];
  
    function getParam(search, key) {
      var m = new RegExp('[?&]' + key + '=([^&#]*)').exec(search || '');
      return m ? decodeURIComponent(m[1]) : null;
    }
  
    function readCookie(cookieStr, name) {
      var m = new RegExp('(?:^|; )' + name + '=([^;]*)').exec(cookieStr || '');
      return m ? decodeURIComponent(m[1]) : null;
    }
  
    function buildCookie(name, value, days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 864e5);
      return name + '=' + encodeURIComponent(value) +
        '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
    }
  
    function pickClickId(search) {
      for (var i = 0; i < IDS.length; i++) {
        var v = getParam(search, IDS[i]);
        if (v) return v;
      }
      return null;
    }
  
    function resolveClickId(search, cookieStr) {
      return pickClickId(search) || readCookie(cookieStr, COOKIE);
    }
  
    // Jotform URL'sine gclid ekler. Zaten varsa dokunmaz (sonsuz dongu onlemi).
    function addGclid(url, value) {
      if (!url || !value) return url;
      if (url.indexOf('jotform') === -1) return url;
      if (/[?&]gclid=/.test(url)) return url;
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'gclid=' + encodeURIComponent(value);
    }
  
    function needsPatch(url, value) {
      return addGclid(url, value) !== url;
    }
  
    function init() {
      var fresh = pickClickId(window.location.search);
      if (fresh) document.cookie = buildCookie(COOKIE, fresh, DAYS);
  
      var id = resolveClickId(window.location.search, document.cookie);
      if (!id) return;
  
      function patch(frame) {
        var src = frame.getAttribute('src');
        if (needsPatch(src, id)) frame.setAttribute('src', addGclid(src, id));
      }
  
      // Sayfada zaten dolu bir iframe varsa yakala.
      document.querySelectorAll('iframe[src*="jotform"]').forEach(patch);
  
      // Asil is: src sonradan atandiginda mudahale et.
      // popup-root birden fazla oldugu icin tum belgeyi izliyoruz.
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var r = records[i];
          if (r.type === 'attributes' && r.target.tagName === 'IFRAME') {
            patch(r.target);
          } else if (r.type === 'childList') {
            r.addedNodes.forEach(function (n) {
              if (n.nodeType !== 1) return;
              if (n.tagName === 'IFRAME') patch(n);
              else if (n.querySelectorAll) n.querySelectorAll('iframe').forEach(patch);
            });
          }
        }
      }).observe(document.documentElement, {
        subtree: true, childList: true,
        attributes: true, attributeFilter: ['src']
      });
    }
  
    if (typeof window !== 'undefined') {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else { init(); }
    }
  
    if (typeof module !== 'undefined') {
      module.exports = { getParam, readCookie, buildCookie, pickClickId, resolveClickId, addGclid, needsPatch };
    }
  })();